import { getConfig } from "lib/get-config";

// Параметры партнёрской аналитики, которые нужно пробрасывать
// из URL читалки в ссылки на покупку. Порядок повторяет or4
// (GetParntersUtm в UrlParser.ts) и lfrom добавляется первым.
const PARAM_ORDER = [
  "lfrom",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "advcake_params",
  "utm_term",
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "keyword",
  "erid",
  "advcake_method",
  "m",
] as const;

export function appendTrackingParams(
  url: string,
  search: string = window.location.search
): string {
  const params = new URLSearchParams(search);
  const hashIndex = url.indexOf("#");
  const [base, hash] =
    hashIndex === -1
      ? [url, ""]
      : [url.slice(0, hashIndex), url.slice(hashIndex)];

  const queryIndex = base.indexOf("?");
  const existing =
    queryIndex === -1
      ? new URLSearchParams()
      : new URLSearchParams(base.slice(queryIndex + 1));

  const parts: string[] = [];
  for (const name of PARAM_ORDER) {
    if (params.has(name) && !existing.has(name)) {
      parts.push(`${name}=${params.get(name) ?? ""}`);
    }
  }

  // Для пробного фрагмента метим источник.
  if (getConfig().trials === 1 && !existing.has("source_internal")) {
    parts.push("source_internal=trial_fragment");
  }

  if (parts.length === 0) return url;

  const tail = parts.join("&");
  const sep = queryIndex === -1 ? "?" : "&";
  return `${base}${sep}${tail}${hash}`;
}
